import {
  add,
  addOutline,
  albumsOutline,
  alertCircle,
  alertCircleOutline,
  archive,
  arrowBack,
  arrowForwardSharp,
  arrowUndo,
  arrowUp,
  arrowUpOutline,
  backspaceOutline,
  ban,
  banOutline,
  bookOutline,
  briefcase,
  briefcaseOutline,
  calculator,
  calendarOutline,
  callOutline,
  card,
  cart,
  cashOutline,
  chatboxOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkDoneCircle,
  chevronBackOutline,
  chevronCollapse,
  chevronCollapseOutline,
  chevronDownOutline,
  chevronExpand,
  chevronExpandOutline,
  chevronForward,
  chevronForwardOutline,
  chevronUpOutline,
  clipboardOutline,
  close,
  closeCircle,
  closeCircleOutline,
  closeCircleSharp,
  closeOutline,
  codeWorking,
  copyOutline,
  create,
  createOutline,
  document as documentIcon,
  documentText,
  documentTextOutline,
  download,
  downloadOutline,
  earth,
  ellipseOutline,
  ellipsisHorizontal,
  ellipsisVertical,
  ellipsisVerticalCircle,
  ellipsisVerticalSharp,
  exitOutline,
  extensionPuzzleOutline,
  eye,
  fileTrayFullOutline,
  filterOutline,
  flagOutline,
  flash,
  glassesOutline,
  helpBuoy,
  helpCircleOutline,
  hourglass,
  hourglassOutline,
  informationCircle,
  informationCircleOutline,
  key,
  layersOutline,
  libraryOutline,
  link,
  list,
  listOutline,
  mail,
  mailOutline,
  megaphoneOutline,
  menuOutline,
  pause,
  pauseCircle,
  pencil,
  people,
  peopleCircleOutline,
  peopleOutline,
  person,
  personAdd,
  personAddOutline,
  personCircleOutline,
  personOutline,
  personRemoveOutline,
  play,
  pricetag,
  pricetagOutline,
  pricetags,
  pricetagsOutline,
  refresh,
  refreshCircle,
  refreshOutline,
  remove,
  removeCircle,
  removeOutline,
  reorderTwoOutline,
  repeatOutline,
  resize,
  ribbon,
  rocketOutline,
  scaleOutline,
  searchOutline,
  settingsOutline,
  shieldCheckmarkOutline,
  shieldHalfOutline,
  sparkles,
  speedometerOutline,
  star,
  swapHorizontal,
  swapVerticalOutline,
  sync,
  syncOutline,
  thumbsDownSharp,
  thumbsUpSharp,
  time,
  timeOutline,
  trailSign,
  trash,
  trashBin,
  trashOutline,
  wallet,
  walletOutline,
  warning,
  warningOutline,
} from 'ionicons/icons';

export {
  add,
  addOutline,
  albumsOutline,
  alertCircle,
  alertCircleOutline,
  archive,
  arrowBack,
  arrowForwardSharp,
  arrowUndo,
  arrowUp,
  arrowUpOutline,
  backspaceOutline,
  ban,
  banOutline,
  bookOutline,
  briefcase,
  briefcaseOutline,
  calculator,
  calendarOutline,
  callOutline,
  card,
  cart,
  cashOutline,
  chatboxOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkDoneCircle,
  chevronBackOutline,
  chevronCollapse,
  chevronCollapseOutline,
  chevronDownOutline,
  chevronExpand,
  chevronExpandOutline,
  chevronForward,
  chevronForwardOutline,
  chevronUpOutline,
  clipboardOutline,
  close,
  closeCircle,
  closeCircleOutline,
  closeCircleSharp,
  closeOutline,
  codeWorking,
  copyOutline,
  create,
  createOutline,
  documentIcon,
  documentText,
  documentTextOutline,
  download,
  downloadOutline,
  earth,
  ellipseOutline,
  ellipsisHorizontal,
  ellipsisVertical,
  ellipsisVerticalCircle,
  ellipsisVerticalSharp,
  exitOutline,
  extensionPuzzleOutline,
  eye,
  fileTrayFullOutline,
  filterOutline,
  flagOutline,
  flash,
  glassesOutline,
  helpBuoy,
  helpCircleOutline,
  hourglass,
  hourglassOutline,
  informationCircle,
  informationCircleOutline,
  key,
  layersOutline,
  libraryOutline,
  link,
  list,
  listOutline,
  mail,
  mailOutline,
  megaphoneOutline,
  menuOutline,
  pause,
  pauseCircle,
  pencil,
  people,
  peopleCircleOutline,
  peopleOutline,
  person,
  personAdd,
  personAddOutline,
  personCircleOutline,
  personOutline,
  personRemoveOutline,
  play,
  pricetag,
  pricetagOutline,
  pricetags,
  pricetagsOutline,
  refresh,
  refreshCircle,
  refreshOutline,
  remove,
  removeCircle,
  removeOutline,
  reorderTwoOutline,
  repeatOutline,
  resize,
  ribbon,
  rocketOutline,
  scaleOutline,
  searchOutline,
  settingsOutline,
  shieldCheckmarkOutline,
  shieldHalfOutline,
  sparkles,
  speedometerOutline,
  star,
  swapHorizontal,
  swapVerticalOutline,
  sync,
  syncOutline,
  thumbsDownSharp,
  thumbsUpSharp,
  time,
  timeOutline,
  trailSign,
  trash,
  trashBin,
  trashOutline,
  wallet,
  walletOutline,
  warning,
  warningOutline,
};
